// Offset that keeps the target clear of the fixed nav bar.
const RIDE_SCROLL_OFFSET_PX = 140;

/**
 * Smooth-scroll the trip page to an element by id, e.g. a day card
 * ('daily_attraction_day_3') or an accommodation ('42_acommodation_ref_id').
 * Does nothing when the element is not on the page yet.
 */
export function scrollToRideElement(elementId) {
  const element = document.getElementById(elementId);
  if (!element) return;
  const top = element.getBoundingClientRect().top + window.scrollY - RIDE_SCROLL_OFFSET_PX;
  window.scrollTo({ top, behavior: 'smooth' });
}

export function scrollToRideDay(dayIndex) {
  scrollToRideElement('daily_attraction_day_' + dayIndex);
}
